import { render, staticRenderFns } from "./modalCourierConfirm.vue?vue&type=template&id=5b30a4aa&"
import script from "./modalCourierConfirm.vue?vue&type=script&lang=js&"
export * from "./modalCourierConfirm.vue?vue&type=script&lang=js&"
import style0 from "./modalCourierConfirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports